import { useOutletContext } from "react-router-dom";
import { AcuityCalendarForm } from "./AcuityCalendarForm";
import { IntegrationShell } from "../common/Shell";

function AcuityScheduling() {
  const { projectId, isViewOnly } = useOutletContext<{ projectId: string; isViewOnly: boolean }>();

  return (
    <IntegrationShell>
      <AcuityCalendarForm projectId={projectId} isViewOnly={isViewOnly}/>
    </IntegrationShell>
  );
}

export { AcuityScheduling };
